<template>
  <div>

    <dashboard-header></dashboard-header>

    <v-container
      class="mb-3"
    >
      <v-layout
        class="mb-3 noprint"
      >
        <v-flex text-md-right>
          <v-btn 
            outline
            large 
            class="secondary secondary--text noprint"
            to="/dashboard"
          >
            Home
          </v-btn>
          <v-btn 
            large
            class="accent noprint"
            @click="handleSaveAsPdf"
          >
            Save as PDF
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <v-card
            class="pa-5 certificate_bg"
            height="1130"
            :style="{ backgroundImage: 'url(' + bg + ')' }"
          >
            <v-layout
              justify-center
              wrap
            >
              <v-flex 
                md6
                xs6
              >
                <div class="mb-5">
                  <img :src="logo" height="80" />
                </div>
              </v-flex>
              <v-flex 
                md6
                xs6
                text-xs-right
              >
                <div class="mb-5">
                  <img :src="merckLogo" height="30" />
                </div>
              </v-flex>
              <v-flex 
                xs12
                text-xs-center
              >
                <div class="display-3">
                  <strong class="deep-purple--text darken-2">Certificate of Completion</strong>
                </div>
                <div
                  class="grey--text text--darken-1"
                  :style="styles.text">
                  This certificate is presented to:
                </div>

                <div
                  class="display-1 accent--text my-3"
                >
                  <strong style="font-size: 26px;">DR. {{ user.firstname.toUpperCase() }} {{ user.middlename.toUpperCase() }} {{ user.lastname.toUpperCase() }}</strong>
                </div>
              </v-flex>

              <v-flex xs8>
                <v-divider></v-divider>
              </v-flex>

              <v-flex xs10 text-xs-center>
                <p class="grey--text text--darken-1" :style="styles.text">
                  for successfully completing the course on
                  <br/>
                  <span style="font-size: 25px;">
                    <span class="deep-purple--text darken-2" style="text-transform: uppercase;font-weight: bold;">{{moduleTitle}}</span>
                  </span>
                  <br/>
                  Issued on : {{dateToday}}
                  <br/>
                  <small><span class="accent--text"  style="font-weight: bold;">1 CDP Unit</span></small>
                  <div>
                  <!-- <small>(Ref No. {{refNumber[moduleId]}})</small> -->
                  <small>(Ref No. {{moduleCodes}})</small>
                  </div>
                  <div>
                  <small>Elite Online: {{certificateCode}}</small>
                  </div>
                </p>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout class="noprint">
        <v-flex>
          <v-btn
            color="blue"
            block
            flat
            large
            @click="shareToFb"
          >
            <span>Share to Facebook</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-footer 
      height="112"
      class="noprint"
    >
      <main-footer></main-footer>
    </v-footer>

  </div>
</template>

<script>
// import * as jsPDF from 'jsPDF'
import axios from 'axios'
import moment from 'moment'

import DashboardHeader from '@/components/dashboard/dashboardHeader'
import MainFooter from '@/components/mainFooter'

import config from '../../../../configApi'
const apiUrl = config.apiUrl

/* global FB */

export default {
  components: {
    DashboardHeader,
    MainFooter
  },
  computed: {
    formattedCertificateTaken () {
      return moment(this.certificateCreated).format('LL')
    },
    dateToday () {
      return moment().format('LL')
    }
  },
  created () {
    // this.getCertificateData(this.certificateCode)
  },
  mounted () {
    this.getCertificateData(this.certificateCode)
  },
  data () {
    return {
      certificateCode: this.$route.params.code,
      logo: require('@/assets/svg/ELITE Logo.svg'),
      merckLogo: require('@/assets/svg/Merck Logo.svg'),
      bg: require('@/assets/bg/certificate.png'),
      user: {
        firstname: 'Juan',
        middlename: 'Dela',
        lastname: 'Cruz'
      },
      moduleId: 1,
      moduleTitle: 'Expert Case Studies in Peripheral T-Cell Lymphoma',
      refNumber: {
        5: 'MED-2018-266-3146',
        4: 'MED-2018-266-3151',
        3: 'MED-2018-266-3148',
        2: 'MED-2018-266-2472',
        1: 'MED-2018-266-3152',
        6: 'MED-2018-266-2475',
        9: 'MED-2018-266-2477',
        10: 'MED-2018-266-3147',
        8: 'MED-2018-266-3149',
        7: 'MED-2018-266-2490',
      },
      moduleCodes: "",
      cpdPoints: 1,
      certificateCreated: '2018-12-19 00:00:00',
      styles: {
        text: {
          fontSize: '1.5rem',
          lineHeight: '2.5em'
        }
      }
    }
  },
  methods: {
    getCertificateData (certCode) {
      axios.get(apiUrl + '/certificate/' + certCode).then(r => {
        console.log(r.data)
        this.user.firstname = r.data.user.firstname ? r.data.user.firstname : ''
        this.user.middlename = r.data.user.middlename ? r.data.user.middlename : ''
        this.user.lastname = r.data.user.lastname ? r.data.user.lastname : ''
        // this.moduleTitle = 'Thyroid Disease Management'
        this.moduleTitle = r.data.module.title
        this.moduleCodes = r.data.module.codes
        this.cpdPoints = 1
        this.moduleId = r.data.module.id
        // this.cpdPoints = r.data.module.cpd_points
        this.certificateCreated = r.data.created_at
      }).catch(e => {

      })
    },
    handleSaveAsPdf () {
      window.print()
      // Default export is a4 paper, portrait, using milimeters for units
      // var doc = jsPDF()

      // doc.addPage()

      // doc.setFontSize(40)
      // doc.text('Certificate of Completion', 10, 40)

      // doc.save('a4.pdf')
    },
    dateToday () {
      return moment().format('LL')
    },
    initiateFacebook () {
      window.fbAsyncInit = function () {
        FB.init({
          appId: '233247144074617',
          xfbml: true,
          version: 'v3.0'
        })
        FB.AppEvents.logPageView()
      };

      (function (d, s, id) {
        var js
        var fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) { return }
        js = d.createElement(s); js.id = id
        js.src = 'https://connect.facebook.net/en_US/sdk.js'
        fjs.parentNode.insertBefore(js, fjs)
      }(document, 'script', 'facebook-jssdk'))
    },
    shareToFb () {
      // FB.ui(
      //   {
      //     method: 'share_open_graph',
      //     action_type: 'og.likes',
      //     action_properties: JSON.stringify({
      //       object: `https://merck.medix.ph`
      //     })
      //   },
      //   // callback
      //   function (response) {
      //     if (response && !response.error_message) {
      //       alert('Posting completed.')
      //     } else {
      //       console.log('Error while posting.')
      //     }
      //   }
      // )
      let urlLink = `${location.origin}/#/certificate/${this.certificateCode}`
      FB.ui({
        method: 'feed',
        link: urlLink,
        caption: 'sample test'
      },
      function (response) {
        console.log(response)
      })
    }
  },
  beforeMount () {
    this.initiateFacebook()
  }
}
</script>

<style>
.certificate_bg {
  background-position: center 340px;
}
</style>
<style type="text/css" media="print">
  @media print
  {
    .noprint {
      display:none !important;
    }
    @page { margin: 0; }
    body { margin-bottom: 0; }
  }
</style>


// WEBPACK FOOTER //
// src/components/module/certificate/index.vue